import type { Socket } from 'socket.io-client'

export const listenTotalUnreadNotifications = (
  socket: Socket,
  callback: (totalUnreadNotifications: number) => void,
) => {
  socket.on(
    'sendTotalUnreadNotifications',
    (totalUnreadNotifications: number) => {
      callback(totalUnreadNotifications)
    },
  )
}

export const offListenTotalUnreadNotifications = (socket: Socket) => {
  socket.off('sendTotalUnreadNotifications')
}
